<template>
  <div class="text-danger">
    <slot name="header">
      <h5>Error</h5>
    </slot>
    <slot name="content">
      There was an error with the form
    </slot>
  </div>

</template>

<script>
export default {

}
</script>
